@if (hasMedia()) {
  <div class="flex flex-col gap-4">
    @if (!metadataLoaded()) {
      <mat-progress-bar mode="indeterminate" />
    }

    <div class="border-b border-slate-200 pb-3">
      <p class="mb-1 text-xs font-medium text-slate-500">
        Selected Attachments
      </p>
      @if (selectedMediaWithThumbnails().length) {
        <mat-chip-set class="flex flex-wrap gap-1">
          @for (
            item of selectedMediaWithThumbnails();
            track item.media.ref.path
          ) {
            <mat-chip (removed)="removeFromSelection(item.media)">
              <mat-icon matChipAvatar>{{
                item.media.name | map: getFileIcon : this
              }}</mat-icon>
              <span class="max-w-[200px] truncate">{{ item.media.name }}</span>
              <button matChipRemove type="button">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          }
        </mat-chip-set>
      } @else {
        <p class="text-sm text-slate-400">No attachments selected</p>
      }
    </div>

    <div class="flex items-center">
      <button
        mat-button
        type="button"
        [disabled]="metadataLoaded() === false"
        (click)="toggleSelectAll()"
      >
        {{ allSelected() ? 'Deselect All' : 'Select All' }}
      </button>
    </div>

    <div class="flex flex-col gap-1">
      @for (item of mediaWithThumbnails(); track item.media.ref.path) {
        <pr-referral-media-selection-item
          [name]="item.media.name"
          [actorName]="item.media.actor.name"
          [isImage]="item.isImage"
          [isSelected]="item.isSelected()"
          [isDisabled]="item.isValid === false"
          [tooltipText]="item.validationReason ?? ''"
          [thumbnailUrl$]="item.thumbnailUrl$"
          [icon]="item.media.name | map: getFileIcon : this"
          (toggled)="onToggle(item)"
        />
      }
    </div>
  </div>
} @else {
  <p class="text-sm text-slate-500">
    No files available. Upload files in the Files tab to include them as
    attachments.
  </p>
}
